import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './instagram.css'

const Instagram = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      className={`instagram-thq-instagram-elm ${props.rootClassName} `}
    >
      <div className="instagram-thq-dropshadow-elm"></div>
      <div className="instagram-thq-text-elm">
        <div className="instagram-container1">
          <div className="instagram-container2">
            <span className="instagram-text1">{props.text}</span>
          </div>
        </div>
        <div className="instagram-container3">
          <div className="instagram-container4">
            <span className="instagram-text2">{props.text1}</span>
            <span className="instagram-text3">{props.text2}</span>
          </div>
          <div className="instagram-container5">
            <a
              href={props.linkOutline1?.['url']}
              target={props.linkOutline1?.['newTab'] ? '_blank' : undefined}
              rel={
                props.linkOutline1?.['newTab']
                  ? 'noreferrer noopener'
                  : undefined
              }
              className="instagram-prop-link1"
            >
              <img
                alt={props.outlineAlt1}
                src={props.outlineSrc1}
                className="instagram-thq-outline-elm"
              />
            </a>
            <a
              href={props.linkIcon1?.['url']}
              target={props.linkIcon1?.['newTab'] ? '_blank' : undefined}
              rel={
                props.linkIcon1?.['newTab'] ? 'noreferrer noopener' : undefined
              }
              className="instagram-prop-link2"
            >
              <svg viewBox="0 0 1024 1024" className="instagram-icon1">
                <path d="M298.667 341.333h323.669l-353.835 353.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l353.835-353.835v323.669c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-426.667c0-5.803-1.152-11.307-3.243-16.341s-5.163-9.728-9.216-13.781c-0.043-0.043-0.043-0.043-0.085-0.085-3.925-3.925-8.619-7.083-13.781-9.216-5.035-2.091-10.539-3.243-16.341-3.243h-426.667c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="instagram-thq-container-elm">
        {isVisible === true && (
          <img
            alt={props.imageAlt11}
            src={props.imageSrc11}
            loading="eager"
            className="instagram-thq-image2-elm"
          />
        )}
        <img
          alt={props.imageAlt1}
          src={props.imageSrc2}
          loading="eager"
          className="instagram-thq-image1-elm"
        />
      </div>
    </div>
  )
}

Instagram.defaultProps = {
  imageSrc2: '/socials/11-1500w.jpg',
  linkOutline1: {
    url: 'https://www.instagram.com/romania/',
    newTab: false,
  },
  text2:
    'Follow @Romania on Instagram and get ready to add some seriously amazing travel destinations to your bucket list',
  text: '@Romania on Instagram',
  imageSrc11: '/socials/1a-1500w.jpg',
  outlineAlt1: 'image',
  linkIcon1: {
    url: 'https://www.instagram.com/romania/',
    newTab: false,
  },
  rootClassName: '',
  imageAlt11: 'image',
  text1: 'Explore Best-kept Secrets',
  imageAlt1: 'image',
  outlineSrc1: '/socials/heart_outline.svg',
}

Instagram.propTypes = {
  imageSrc2: PropTypes.string,
  linkOutline1: PropTypes.object,
  text2: PropTypes.string,
  text: PropTypes.string,
  imageSrc11: PropTypes.string,
  outlineAlt1: PropTypes.string,
  linkIcon1: PropTypes.object,
  rootClassName: PropTypes.string,
  imageAlt11: PropTypes.string,
  text1: PropTypes.string,
  imageAlt1: PropTypes.string,
  outlineSrc1: PropTypes.string,
}

export default Instagram
